
import roles from "@/store/modules/admin/roles";
import logRole from "@/store/modules/admin/logRole";
import cars  from "@/store/modules/admin/cars";
import fields from "@/store/modules/admin/fields";
import visitors from "@/store/modules/admin/visitors";
import orders from "@/store/modules/admin/orders";
import logGuardPost from "@/store/modules/admin/logGuardPost"
import logStatus from "@/store/modules/admin/logStatus"
import chats from "@/store/modules/admin/chats";
import organizations from "@/store/modules/admin/organizations";
import bans from "@/store/modules/admin/bans";
import guardPosts from "@/store/modules/admin/guardposts";
import file from "@/store/modules/admin/file";
import replacements from "@/store/modules/admin/replacements";


export default {
  namespaced: true,
  modules: {
    roles,
    cars,
    fields,
    visitors,
    orders,
    logGuardPost,
    logStatus,
    logRole,
    chats,
    guardPosts,
    organizations,
    replacements,
    bans,
    file
  }
}
